import { render, staticRenderFns } from "./EditFileTransferModal.vue?vue&type=template&id=02a86992&scoped=true&"
import script from "./EditFileTransferModal.vue?vue&type=script&lang=js&"
export * from "./EditFileTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFileTransferModal.vue?vue&type=style&index=0&id=02a86992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a86992",
  null
  
)

export default component.exports